export default {
  'user.query.deptKeyword.placeholder': '输入关键字进行过滤',
  'user.query.nickname': '用户名称',
  'user.query.nickname.placeholder': '输入要查找的用户名称',
  'user.query.mobile': '手机号',
  'user.query.mobile.placeholder': '输入要查找的手机号',
  'user.query.username': '登录名',
  'user.query.username.placeholder': '输入要查找的登录名',
  'user.query.lastActiveTime': '最后活跃时间',
  'user.query.lastActiveTime.start-placeholder': '开始时间',
  'user.query.lastActiveTime.end-placeholder': '结束时间',
  'user.column.username': '登录名',
  'user.column.nickname': '用户昵称',
  'user.column.deptId': '部门',
  'user.column.mobile': '手机号码',
  'user.column.email': '邮箱',
  'user.column.sex': '性别',
  'user.column.status': '状态',
  'user.column.lastActiveTime': '最后活跃时间',
  'user.column.createTime': '创建时间',
  'user.column.operation.more': '更多',
  'user.column.operation.resetPwd': '重置密码',
  'user.column.operation.assignRole': '分配角色',
  'user.confirm.resetPwd.message': '请输入"{nickname}"的新密码',
  'user.confirm.resetPwd.errorMessage': '用户密码长度必须介于 6 ~ 20 之间',
  'user.confirm.resetPwd.successMessage': '密码重置成功，新密码是：{newPassword}',
  'user.confirm.toggleStatus.message': '确认要{status}"{nickname}"吗？',
  'user.confirm.toggleStatus.success': '{status}成功',
  // assign role
  'user.assignRole.title': '分配角色',
  'user.assignRole.role.placeholder': '请选择角色',
  'user.assignRole.success': '分配角色成功',
  // edit
  'user.edit.title': '修改用户',
  'user.edit.success': '修改成功',
  'user.add.title': '新增用户',
  'user.add.success': '新增成功, 默认密码为：{password}',
  'user.edit.form.nickname': '用户昵称',
  'user.edit.form.nickname.placeholder': '请输入用户昵称',
  'user.edit.form.nickname.required': '请输入用户昵称',
  'user.edit.form.username': '登录名',
  'user.edit.form.username.placeholder': '请输入登录名',
  'user.edit.form.username.required': '请输入登录名',
  'user.edit.form.mobile': '手机号码',
  'user.edit.form.mobile.placeholder': '请输入手机号码',
  'user.edit.form.mobile.required': '请输入手机号码',
  'user.edit.form.mobile.pattern': '手机号码格式不正确',
  'user.edit.form.sex': '用户性别',
  'user.edit.form.sex.required': '请选择用户性别',
  'user.edit.form.sex.man': '男',
  'user.edit.form.sex.woman': '女',
  'user.edit.form.email': '邮箱',
  'user.edit.form.email.placeholder': '请输入邮箱',
  'user.edit.form.deptId': '部门',
  'user.edit.form.deptId.placeholder': '请选择部门',
  'user.edit.form.postIds': '岗位',
  'user.edit.form.postIds.placeholder': '请选择岗位',
  'user.edit.form.roleIds': '角色',
  'user.edit.form.roleIds.placeholder': '请选择角色',
  'user.edit.form.remark': '备注',
  'user.edit.form.remark.placeholder': '请输入内容',
}
